import { twMerge } from 'tailwind-merge';

interface TableTitleProps {
  text: string;
  textClassName?: string;
}

export const TableTitle = ({ text, textClassName }: TableTitleProps) => {
  return (
    <div
      className={twMerge(
        'text-black-071336 font-semibold dark-mode:text-gray-500',
        textClassName
      )}
    >
      {text}
    </div>
  );
};
